export default "__VITE_ASSET__9194b43b__"